module.exports = __webpack_public_path__ + "fonts/257c802f-349c-4b4d-aefa-546d5de15ec6.4695ade0.eot";